export const redirectToHttps = () => {
    if (window.location.host.startsWith('localhost:'))
        return;
    if (window.location.protocol.startsWith('https'))
        return;
    window.location.href = window.location.href.replace('http:', 'https:');
};
